<template>
  <div :class="['contact-product-search', { 'dropdown-open': isDropdownOpen }]">
    <!-- List -->
    <div class="form-contact-product__list">
      <div class="form-contact-product__text">
        <p
          class="text-medium"
          v-html="
            $t(
              searchedProducts.length === 1
                ? 'form.forProduct'
                : 'form.forProducts',
            )
          "
        />
      </div>
      <div>
        <ul class="form-contact-product__list__items">
          <li
            class="form-contact-product__list__item"
            v-for="(product, index) in searchedProducts"
            :key="index"
          >
            <span v-if="index <= 0" class="text-base">{{ product }}</span>
            <span
              v-else
              @click="onRemove(index)"
              class="text-base form-contact-product__list__item__content"
              >{{ product }}
              <img
                src="@/assets/img/ico/close-product.svg?url"
                alt="Close"
                width="15"
                height="15"
            /></span>
          </li>
        </ul>
      </div>
    </div>

    <div class="contact-product-search__intro">
      <h2 class="title-base3" v-html="$t('form.otherProducts')" />
      <!--<p class="text-medium" v-html="$t('form.otherProductsText')" />-->
    </div>

    <div class="contact-product-search__input__wrap">
      <input
        type="text"
        ref="searchInput"
        @input="fetchResults"
        class="contact-product-search__input"
        :placeholder="$t('form.searchPlaceholderProducts')"
        id="input_search_product"
      />
      <img
        class="contact-product-search__input-container__ico"
        src="~/assets/img/ico/search-icon-mobile.svg?url"
        alt="Search"
        width="20"
        height="20"
      />
    </div>

    <ul
      data-lenis-prevent
      class="contact-product-search__dropdown"
      v-if="results.length && search"
    >
      <li
        v-for="(result, index) in results"
        :key="index"
        @click="selectResult(result)"
        class="text-medium contact-product-search__dropdown__item"
        v-html="result.highlighted"
      />
    </ul>
  </div>
</template>

<script setup>
import { useStore } from '@/store/index.js'
import queries from '@/graphql/craft/queries/index.js'

const emit = defineEmits(['select', 'remove'])

const { configuration } = useStore()

// Fetch Data
const query = queries.contatti.getContactsSearched

const searchInput = ref(null)
const search = ref('')
const results = ref([])

const variables = computed(() => ({
  site: 'it',
  type: ['vino', 'birra'],
  search: `title:${search.value}*`,
}))

const { data } = await useGraphql(query, variables)

const props = defineProps({
  searchedProducts: Array,
})

watch(
  () => data.value,
  (data) => {
    results.value = data.entries.map((entry) => ({
      original: entry.title,
      highlighted: highlightSearch(entry.title),
    }))
  },
)

const fetchResults = (event) => {
  if (event.target.value) {
    search.value = event.target.value
  } else {
    results.value = []
  }
}

const selectResult = (result) => {
  searchInput.value.value = ''
  search.value = ''
  results.value = []

  emit('select', result.original)
}

const onRemove = (index) => {
  props.searchedProducts.splice(index, 1)
}

const isDropdownOpen = computed(() => results.value.length && search.value)

const highlightSearch = (text) => {
  const regex = new RegExp(`(${search.value})`, 'gi')
  return text.replace(regex, '<b>$1</b>')
}
</script>

<script>
export default {
  name: 'ContactProductSearch',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
